
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxCastelnaudary = () => {
  return (
    <CityMetauxPage
      cityName="Castelnaudary"
      departmentName="Aude"
      departmentCode="11"
      region="Occitanie"
      description="Ville historique du Lauragais connue pour son cassoulet, Castelnaudary bénéficie de notre expertise dans le rachat de métaux issus de l'agroalimentaire, de l'agriculture et de l'artisanat local."
      specialities={[
        "Métaux agroalimentaires",
        "Équipements agricoles du Lauragais",
        "Métaux de conserverie",
        "Ferraille artisanale et locale"
      ]}
      nearbyAreas={[
        "Villeneuve-la-Comptal", "Mas-Saintes-Puelles", "Salles-sur-l'Hers", "Baraigne", "Ricaud", "Villepinte"
      ]}
      heroImage="https://images.unsplash.com/photo-1551218372-a8789b81b253?w=1280&q=80"
    />
  );
};

export default AchatMetauxCastelnaudary;
